import store from "app/store/store";
import { toUrlFriendlyName } from "../screens/EventsScreen/screens/CompetitionScreenWrapper/nameHelper";

export const getNumberOfEventsForTodayForSportId = (
  selectedSportId: number,
  sportsSelectionList: any[]
): number => {
  // Find the selected sport in the list of sports
  const sportsSelectionListSport =
    selectedSportId &&
    sportsSelectionList &&
    sportsSelectionList.find(sport => {
      return sport.sportNavNodeId === +selectedSportId;
    });

  const numberOfEventsTODAY = sportsSelectionListSport
    ? sportsSelectionListSport.numberOfEventsDescriptions.numberOfEventsDescriptions.find(
        numberOfEventsDescription => numberOfEventsDescription.name === "Today"
      )?.number || 0
    : 0;

  return numberOfEventsTODAY;
};

export const determineTimeFilter = (
  selectedSportId: number | null,
  sportsSelectionList: any[]
): "TODAY" | "EARLY" => {
  const hasEventsToday = selectedSportId
    ? getNumberOfEventsForTodayForSportId(
        selectedSportId,
        sportsSelectionList
      ) > 0
    : true;
  return hasEventsToday ? "TODAY" : "EARLY";
};

interface BuildNavigationUrlParams {
  basePath: string;
  filter: string;
  sportId: number | null;
  sportsSelectionList: any[];
  selectedCountryName?: string | null;
}

export const buildNavigationUrl = ({
  basePath,
  filter,
  sportId,
  sportsSelectionList,
  selectedCountryName,
}: BuildNavigationUrlParams): string => {
  const searchParams = new URLSearchParams();
  searchParams.set("filter", filter.toLowerCase());

  if (filter.toLowerCase() === "all") {
    const period = determineTimeFilter(sportId, sportsSelectionList);
    searchParams.set("period", period.toLowerCase());
  }

  if (selectedCountryName) {
    searchParams.set("country", selectedCountryName);
  }

  return `${basePath}?${searchParams.toString()}`;
};

/**
 * Extracts the filter and period from the current URL
 * @returns {string} The filter and period as a string
 */
export const extractUrlFilterParams = (): string => {
  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);
  const filter = searchParams.get("filter");
  if (!filter) {
    return "";
  }
  if (filter?.toLowerCase() === "all") {
    const period = searchParams.get("period");
    if (!period) {
      return `filter=${filter}`;
    }
    return `filter=${filter}&period=${period}`;
  }
  return `filter=${filter}`;
};

/**
 * Builds a URL tp load an event that combines the event ID with a URL-friendly name
 * @param eventId - The ID of the event
 * @param name - The name to be converted to URL-friendly format
 * Only eventId is used for the navigation
 * name is used for SEO/readability
 * @returns {string} The formatted event URL
 */
export const buildEventNavigationUrl = (
  eventId: string | number,
  name: string
): string => {
  const urlFriendlyName = toUrlFriendlyName(name);
  return `/event/${eventId}-${urlFriendlyName}`;
};

/**
 * Store the current route before navigating to single event
 * so we can apply the same filter when we navigate back
 * only applies to /events/ route
 */
export const storeCurrentRouteAsPrevious = () => {
  const currentPath = window.location.pathname;
  if (currentPath !== "/events/") {
    return;
  }
  const currentSearch = window.location.search;
  const previousRoute = currentPath + currentSearch;
  store.dispatch.navigationModel.storePreviousRoute(previousRoute);
};

/**
 * Gets the competition URL based on the event's competition name
 *
 * @returns {string} The competition URL
 */
export const getCompetitionURL = eventCompetitionName => {
  if (!eventCompetitionName) {
    return "/events";
  }

  return `/competition/${toUrlFriendlyName(eventCompetitionName)}`;
};
